// extracted by mini-css-extract-plugin
export default {"inputs":"Inputs_inputs__g7NZb","inputsPadding":"Inputs_inputsPadding__Cge+p","inputsAdornment":"Inputs_inputsAdornment__Hlxcy","copyIconWrapper":"Inputs_copyIconWrapper__sOj+n"};